// Components
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/**
 * Single chart dashboard layout. This layout contains 1 row for 1 chart at full dashboard width.
 * @component
 * @param {Object} props - The component accepts props.
 * @param {component} props.chart1 - A chart component.
 * @param {React.JSX.Element} props.chartFootnote1 - A chart footnote component for chart1.
 * @returns A layout for a comparator dashboard.     
 */
const SingleChartLayout = ({
  chart1,
  chartFootnote1
}) => {
  return (
    <>     
      
      {/* 1 chart */}
      <Row className="pt-3 g-3">
        <Col>
          {chart1}
          {chartFootnote1}
        </Col>    
      </Row>

    </>
  );
}

export default SingleChartLayout;